import { render, staticRenderFns } from "./moneyBoxDeltaBox.vue?vue&type=template&id=0e12c23b&"
import script from "./moneyBoxDeltaBox.vue?vue&type=script&lang=ts&"
export * from "./moneyBoxDeltaBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports